/* eslint-disable default-param-last */
import Path from '@leverege/path'
import Constants from './Constants.js'
import createSelectors from './createSelectors.js'

const initialState = {
  map : {
    style : 'vector'
  }
}

function ui( state = initialState, action ) {
  if ( action.type === Constants.UI_SET_KEY ) {
    const nState = Path( action.key ).copy( state, action.value )
    return nState
  }
  if ( action.type === Constants.UI_MULTI_SET_KEY ) {
    let nState = { ...state }
    Object.keys( action.update ).forEach( ( path ) => {
      nState = Path( path ).copy( nState, action.update[path] )
    } )
    return nState
  }
  return state;
}

function get( state, path ) {
  return Path.get( path, state )
}

ui.createSelectors = ( key, createSetStateKey = false ) => {
  return createSelectors( key, { get }, createSetStateKey )
}

const selectors = ui.createSelectors( 'ui', true )
Object.keys( selectors ).forEach( ( key ) => { ui[key] = selectors[key] } )

export default ui
